import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";
import { CurrencyModel } from "../models/InvoiceExtractionModels";
import { environment } from "../config/environment";

export const useCurrencies = (businessTenantId?: string | null) => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<CurrencyModel[]>(
    `${environment.apiUrl}/api/invoices/currencies`,
    (url: string) => {
      if (businessTenantId) {
        return fetcher(url, { headers: { "Business-Tenant": businessTenantId } });
      }
      return fetcher(url);
    },
    {}
  );

  return {
    currencies: data,
    isLoading,
    error,
  };
};
